import React from "react";
import { Tree } from "antd";
import type { GetProps } from "antd";
import { buildTreeFromPaths } from "@/utils/treeViewParser";

type DirectoryTreeProps = GetProps<typeof Tree.DirectoryTree>;

const { DirectoryTree } = Tree;

type DirectoryProps = {
  files: string[];
  onSelect?: DirectoryTreeProps["onSelect"];
};

export const Directory: React.FC<DirectoryProps> = ({ files, onSelect }) => {
  const treeData = buildTreeFromPaths(files);

  const onExpand: DirectoryTreeProps["onExpand"] = (keys, info) => {
    console.log("Trigger Expand", keys, info);
  };

  return (
    <div className="w-full h-full overflow-scroll p-3 bg-white">
      <DirectoryTree
        className="w-full"
        multiple
        defaultExpandAll
        onSelect={onSelect}
        onExpand={onExpand}
        treeData={treeData}
      />
    </div>
  );
};
